import { createClient } from '@supabase/supabase-js'

// These will be auto-injected during deployment
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://vcdzrdublspuulcqldkl.supabase.co'
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjZHpyZHVibHNwdXVsY3FsZGtsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIzOTMwMjYsImV4cCI6MjA3Nzk2OTAyNn0.ZkefcY_6uhNe5ZHo_0N7AZPY2p3TkZ3maOlmQhTYn_I'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables')
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})

// TEMPORARY: Expose Supabase client to window for debugging
if (import.meta.env.DEV) {
  window.supabase = supabase;
}

export default supabase